import React from "react";
import EditUserForm from "../Components/UsersManagement/EditUser/EditUserForm";

function EditUser() {
  return (
    <div className="p-9">
      <EditUserForm />
    </div>
  );
}

export default EditUser;
